import { get, mapValues, omit, values } from "lodash";
import * as React from "react";

export interface Props {
  locale?: string;
  value?: object;
  children?: (
    lang: any,
    originalLang: string,
    i: number,
    originalLangs: string[]
  ) => void;
  defaultOrder?: string[];
}

export interface State {
  value: { [key: string]: any };
}

const initialValue = {
  en_GB: "",
  zh_HK: "",
  zh_CN: "",
  ms_MY: "",
};

export class MultiLangField extends React.Component<Props, State> {
  static defaultProps = {
    value: initialValue,
  };
  readonly state = {
    value: this.getFormattedValue() as any,
  };

  public static translateValue = (value: object, locale = "en-GB") => {
    const data = get(value, locale.replace("-", "_"));
    return data || getFirstNonNullValue(value);
  };

  public render() {
    const { children } = this.props;
    return children ? this.renderFields() : this.renderText();
  }

  private renderFields() {
    const { children } = this.props;
    const { value } = this.state;
    return this.sortLangsByLocale().map(
      (key, i: number, keys) =>
        children && children(value[key].lang, key, i, keys)
    );
  }

  private renderText() {
    const { value, locale } = this.props;
    return MultiLangField.translateValue(value!, locale);
  }

  private getFormattedValue() {
    const { value } = this.props;
    return mapValues(
      omit(value || initialValue, "__typename"),
      (value, key) => ({
        value,
        lang: key.replace("_", "-"),
      })
    );
  }

  private sortLangsByLocale = () => {
    const { locale, defaultOrder } = this.props;
    const { value } = this.state;
    const order = defaultOrder || Object.keys(value);
    if (!locale) {
      return order;
    }
    return order.sort((key) => (value[key].lang === locale ? -1 : 1));
  };
}

const getFirstNonNullValue = (source: object) => {
  return values(source).find((value) => value) || "";
};

export default MultiLangField;
